<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
    <v-container class="whitesmoke" fluid>
      <v-row class="whitesmoke tab" no-gutters>
          <v-alert
              v-if="device?.data?.properties === undefined"
              color="error"
              class="mx-1"
              dense
              outlined
              icon="mdi-alert-circle-outline"
              type="error"
              >
              {{$t('comboNoData')}}
          </v-alert>
      </v-row>
      <v-row v-if="device?.data?.properties !== undefined" class="whitesmoke tab" no-gutters>
          <DeviceOverviewCard
              v-if="device?.data?.properties?.voltage?.voltage_a !== undefined"
              :title="$t('voltage')"
              :title_number="device?.data?.properties?.voltage?.voltage_a?.toFixed(1)"
              text_font_size="20px"
              unit="voltage"
              card_icon="mdi-transmission-tower"
              card_icon_color="green"
          ></DeviceOverviewCard>
          <DeviceOverviewCard
              v-if="device?.data?.properties?.power?.power_a !== undefined"
              :title="$t('power')"
              :title_number="device?.data?.properties?.power?.power_a?.toFixed(1)"
              text_font_size="20px"
              unit="watt"
              card_icon="mdi-home-lightning-bolt-outline"
              card_icon_color="cyan"
          ></DeviceOverviewCard>
          <!-- <DeviceOverviewCard
              v-if="device?.data?.properties.energy.energy_a !== undefined"
              :title="$t('energy')"
              :title_number="device?.data?.properties.energy.energy_a?.toFixed(2)"
              text_font_size="20px"
              card_icon="mdi-meter-electric-outline"
              unit="wmin"
              card_icon_color="red"
          ></DeviceOverviewCard> -->
          <DeviceOverviewCard
              v-if="device?.data?.properties?.energy_day?.energy_day_a !== undefined"
              :title="$t('energy_day')"
              :title_number="device?.data?.properties?.energy_day?.energy_day_a?.toFixed(1)"
              text_font_size="20px"
              card_icon="mdi-meter-electric-outline"
              unit="kwh"
              card_icon_color="red"
          ></DeviceOverviewCard>
            <DeviceOverviewCard
              v-if="device?.data?.properties?.relay?.relay_a !== undefined"
              :title="$t('relay')"
              :title_number="device?.data?.properties?.relay?.relay_a?.toFixed(1)"
              text_font_size="20px"
              :card_icon=" device?.data?.properties?.relay?.relay_a ? 'mdi-light-switch' : 'mdi-light-switch-off'"
              unit="state"
              state=true
              card_icon_color="blue"
          ></DeviceOverviewCard>
      </v-row>
    </v-container>
</template>


<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'
import DashboardCardBarChart from "@/components/Cards/DashboardCardBarChart.vue";
import DashboardCardPieChart from "@/components/Cards/DashboardCardPieChart.vue";
import DeviceOverviewCard from "@/components/Cards/DeviceOverviewCard.vue";
import DeviceOverviewSwitchCard from "@/components/Cards/DeviceOverviewSwitchCard.vue";
import DeviceOverviewButtonCard from "@/components/Cards/DeviceOverviewButtonCard.vue";
import DeviceOverviewHeatingBalanceSliderCard from "@/components/Cards/DeviceOverviewHeatingBalanceSliderCard.vue";
import DashboardCardFaultsPieChart from "@/components/Cards/DashboardCardFaultsPieChart.vue";
import DeviceOverviewRoomTargetCard from "@/components/Cards/DeviceOverviewRoomTargetCard.vue";

@Component({
  components: {
    DashboardCardBarChart,
    DashboardCardPieChart,
    DeviceOverviewCard,
    DeviceOverviewSwitchCard,
    DeviceOverviewButtonCard,
    DeviceOverviewHeatingBalanceSliderCard,
    DeviceOverviewRoomTargetCard,
    DashboardCardFaultsPieChart,
  }
})

export default class SinglePhaseEnergyMeterGeneralView extends Vue {
 @Prop() device: Record<string, any>;

  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

};
</script>

<style scoped lang="scss">
.tab {
  max-height: calc(80vh - 230px) !important;
  overflow-y: auto;
}

div { 
    width:100%;
}
</style>
